import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBrandsData } from "../../../redux/BrandsSlice";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";
import "./TheMilkman.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import { Link } from "react-router-dom";
import GoToBImg from "../../../Assets/Svg/Home/Arrow_Up_Ar.svg";
import ProductsSlider from "../../../Component/ReuseComponent/Products/ProductsSlider";
import ProductsSliderRight from "../../../Component/ReuseComponent/Products/ProductsSliderRight";
import { useIsMobile } from "../../../Component/Hooks/IsMobile/IsMobile";
import { mapProducts } from "../../../Component/ReuseComponent/mapProducts/mapProducts";

export default function TheMilkmanContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { section, brands } = useSelector((state) => state.brands);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!section || section.length === 0 || brands.length === 0) {
      dispatch(fetchBrandsData({ page_id: 4, lang: "ar" }));
    }
  }, [dispatch, section, brands]);

  // section 1
  const section1 = section.find((s) => s.section_id === "1");

  // section 1 title and section 1 products = flavors
  const section2 = brands.find((s) => s.section_id === 2);
  const flavors = section2?.products || [];
  // section 2 products
  const section3 = brands.find((s) => s.section_id === 3);
  const yogurts = section3?.products || [];

  // section 3 products
  const section4 = brands.find((s) => s.section_id === 4);
  const drinkables = section4?.products || [];

  // section 4 products
  const section5 = brands.find((s) => s.section_id === 5);
  const creams = section5?.products || [];

  //  section 5 products
  const section6 = section.find((s) => s.section_id === "6");

  return (
    <>
      <LoaderWrap>
        <div className="TheMilkmanContainer">
          <section>
            <TheMilkmanS1 section1={section1} section2={section2} flavors={flavors} isMobile={isMobile} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="TheMilkmanS2">
            <TheMilkmanS2 section3={section3} yogurts={yogurts} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="TheMilkmanS3">
            <TheMilkmanS3 section4={section4} drinkables={drinkables} />
          </VisibilitySection>
          <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="TheMilkmanS4">
            <TheMilkmanS4 section5={section5} creams={creams} />
          </VisibilitySection>
          <VisibilitySection index={4} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="TheMilkmanS5">
            <TheMilkmanS5 section5={section6} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}

function TheMilkmanS1({ section1, section2, flavors, isMobile }) {
  const product = mapProducts(flavors);

  const finalProducts = isMobile ? product : [...product.slice(-2), ...product.slice(0, -2)];

  if (finalProducts.length === 0) return null;

  return (
    <>
      <div className="TheMilkmanS1">
        <div>
          <img src={section1?.image} alt="" className="TheMilkmanS1Img" />
        </div>
        <TC3L Para={section1?.description} ParaWidth="56vw" />
      </div>
      <div className="TMSP2">
        <TC3L Title={section2?.title} />
        <div className="ProductSliderPage">
          <ProductsSlider products={finalProducts} />
        </div>
      </div>
    </>
  );
}

//
//

function TheMilkmanS2({ section3, yogurts }) {
  const product = mapProducts(yogurts);

  const finalProducts = [...product.slice(-2), ...product.slice(0, -2)];

  if (finalProducts.length === 0) return null;
  return (
    <>
      <div className="TheMilkmanS2">
        <div className="TMSP2">
          <TC3L Title={section3?.title} />
          <div className="ProductSliderPage">
            <ProductsSliderRight products={finalProducts} />
          </div>
        </div>
      </div>
    </>
  );
}

//
//

function TheMilkmanS3({ section4, drinkables }) {
  const product = mapProducts(drinkables);

  if (product[1]) {
    product[1] = {
      ...product[1],
      NameFSize: "1.3vw",
      NameTop: "-10%",
      NameLeft: "0%",
    };
  }

  if (product.length === 0) return null;

  return (
    <>
      <div className="TheMilkmanS3">
        <div className="TMSP2">
          <TC3L Title={section4?.title} />
          <div className="ProductSliderPage">
            <ProductsSlider products={product} />
          </div>
        </div>
      </div>
    </>
  );
}

//
//

function TheMilkmanS4({ section5, creams }) {
  const product = mapProducts(creams);

  if (product.length === 0) return null;

  return (
    <>
      <div className="TheMilkmanS4">
        <div className="TMSP2">
          <TC3L Title={section5?.title} />
          <div className="ProductSliderPage">
            <ProductsSliderRight products={product} />
          </div>
        </div>
      </div>
    </>
  );
}

//
//

function TheMilkmanS5({ section5 }) {
  return (
    <>
      <div className="TheMilkmanS5">
        <div>
          <TC3L Title={section5?.title} Para={section5?.description} ParaWidth="56vw" />
        </div>
        <div className="BoxPPC">{section5?.links && section5?.links.map((link, index) => <SocialLink key={index} href={link.link} text={link.name} />)}</div>
      </div>
    </>
  );
}
function SocialLink({ href, text }) {
  return (
    <Link to={href} target="blank" className="BoxPPCA">
      <div>
        <img src={GoToBImg} alt="" className="BoxImgTPB_ButtonC_Img_New" />
      </div>
      <div className="BoxImgTPB_ButtonC_Text ar">{text}</div>
    </Link>
  );
}
